import { useEffect } from 'react';
import useSWR from 'swr';
import { isDefined } from '@peloton/types';
import { BrowseCategorySlug } from '@engage/browse-categories';
import { useCurrentBrowseCategorySlug } from '@webtv/browse/hooks';
export var useLastBrowseCategory = function useLastBrowseCategory() {
  var maybeCategorySlug = useCurrentBrowseCategorySlug();

  var _useSWR = useSWR('LastBrowseCategory', {
    fallbackData: ''
  }),
      data = _useSWR.data,
      mutate = _useSWR.mutate;

  useEffect(function () {
    if (isBrowseCategorySlug(maybeCategorySlug)) {
      if (maybeCategorySlug !== data) {
        mutate(maybeCategorySlug, false);
      }
    }
  }, [maybeCategorySlug, data, mutate]);
  return data;
};

var isBrowseCategorySlug = function isBrowseCategorySlug(slug) {
  return isDefined(slug) && (slug === 'featured' || Object.values(BrowseCategorySlug).includes(slug));
};